import React, { useState, useEffect } from "react";
import { requestData } from "../services/requests";
import CadastraVendedor from "./Modals/CadastraVendedor";
import DeletarVendedor from "./Modals/DeletarVendedor";
import api from "../services/requests";
import { toast } from "react-toastify";
import { Trash2, User, Phone, Calendar, Link, Clipboard } from "lucide-react";
import StatusToggle from "./painel/StatusToggle";

const VendedoresContent = () => {
  const [vendedores, setVendedores] = useState([]);
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [telefone, setTelefone] = useState("");
  const [expiraEm, setExpiraEm] = useState("");
  const [creationLink, setCreationLink] = useState("");

  const props = {
    nome,
    setNome,
    cpf,
    setCpf,
    telefone,
    setTelefone,
    expiraEm,
    setExpiraEm,
    creationLink,
  };

  const [exibirModalCadastrarVendedores, setExibirModalCadastrarVendedores] =
    useState(false);
  const [exibirModalDeletarVendedor, setExibirModalDeletarVendedor] =
    useState(false);
  const [vendedorIdToDelete, setVendedorIdToDelete] = useState(null);

  const handleOpenModalCadastrarVendedores = () =>
    setExibirModalCadastrarVendedores((prev) => !prev);

  const handleClose = () => {
    setExibirModalCadastrarVendedores(false);
    setCreationLink("");
    setNome("");
    setCpf("");
    setTelefone("");
    setExpiraEm("");
    obterVendedores();
  };

  const handleOpenModalDeletarVendedor = (id) => {
    setVendedorIdToDelete(id);
    setExibirModalDeletarVendedor(true);
  };

  const handleCloseModalDeletarVendedor = () => {
    setVendedorIdToDelete(null);
    setExibirModalDeletarVendedor(false);
  };

  const handleCopyLink = (link) => {
    const fullLink = `${link}`;
    navigator.clipboard.writeText(fullLink);
    toast.success("Link copiado para a área de transferência!");
  };

  const cadastroVendedores = async (nome, cpf, telefone, expiraEm) => {
    try {
      const { data } = await api.post("/vendedores", {
        nome,
        cpf,
        telefone,
        expiraEm,
      });
      setCreationLink(data.creationLink);
      toast.success("Colaborador cadastrado com sucesso!");
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "Erro ao cadastrar colaborador.");
    }
  };

  const deletarVendedor = async (id) => {
    try {
      await api.delete(`/vendedores/${id}`);
      toast.success("Colaborador deletado com sucesso!");
      obterVendedores();
      handleCloseModalDeletarVendedor();
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.error || "Erro ao deletar colaborador.");
    }
  };

  const obterVendedores = async () => {
    try {
      const response = await requestData("/vendedores", "GET");
      if (response && Array.isArray(response)) {
        const vendedoresNormalizados = response.map((v) => ({
          ...v,
          isActive: new Date(v.token_expira_em) > new Date(),
        }));

        setVendedores(vendedoresNormalizados);
      } else {
        setVendedores([]);
      }
    } catch (error) {
      console.error(error);
      toast.warning("Nenhum vendedor encontrado!");
    }
  };

  useEffect(() => {
    obterVendedores();
  }, []);

  const handleStatusToggle = async (id, newIsActive) => {
    const newExpirationDate = new Date();

    if (newIsActive) {
      newExpirationDate.setFullYear(newExpirationDate.getFullYear() + 1);
    } else {
      newExpirationDate.setFullYear(newExpirationDate.getFullYear() - 1);
    }

    try {
      await api.put(`/vendedores/${id}`, {
        token_expira_em: newExpirationDate.toISOString(),
      });
      toast.success("Status do vendedor atualizado com sucesso!");
      obterVendedores();
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.error || "Erro ao atualizar status do vendedor."
      );
    }
  };

  return (
    <>
      <div className="flex-col p-4">
        {" "}
    
        <div className="flex bg-white items-center justify-between mb-4 p-4 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-700">Colaboradores</h2>
          <button
            className="bg-blue-700 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-blue-800 transition-colors"
            onClick={handleOpenModalCadastrarVendedores}
          >
            CADASTRAR COLABORADOR
          </button>
          <CadastraVendedor
            show={exibirModalCadastrarVendedores}
            handleClose={handleClose}
            props={props}
            cadastroVendedores={cadastroVendedores}
          />
          <DeletarVendedor
            show={exibirModalDeletarVendedor}
            handleClose={handleCloseModalDeletarVendedor}
            deletar={deletarVendedor}
            id={vendedorIdToDelete}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {vendedores?.map((vendedor) => {
            return (
              <div
                key={vendedor.id}
                className="bg-white shadow-lg rounded-2xl p-6 flex flex-col justify-between transition-transform transform hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-4">
                  {" "}
                  <div className="flex items-center">
                    <div className="bg-blue-100 p-3 rounded-full mr-4">
                      {" "}
                      <User className="text-blue-500" size={24} />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">
                        {vendedor.nome}
                      </h3>
                      <p className="text-gray-500">CPF: {vendedor.cpf}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleOpenModalDeletarVendedor(vendedor.id)}
                    className="text-gray-400 hover:text-red-600 transition-colors"
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
                <div className="mt-4 border-t border-gray-200 pt-4 space-y-3">
                  <div className="flex items-center text-gray-700">
                    <Phone size={16} className="mr-3 text-blue-500" />
                    <span>{vendedor.telefone || "Telefone não informado"}</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    {vendedor.isActive && (
                      <>
                        <Calendar
                          size={16}
                          className={`mr-3 ${
                            vendedor.isActive
                              ? "text-green-500"
                              : "text-red-500"
                          }`}
                        />
                        <span
                          className={
                            vendedor.isActive ? "" : "text-red-500 font-medium"
                          }
                        >
                          Expira em: {""}
                          {new Date(
                            vendedor.token_expira_em
                          ).toLocaleDateString("pt-BR")}
                        </span>
                      </>
                    )}
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Link
                      size={16}
                      className={`mr-3 ${
                        vendedor.isActive ? "text-blue-500" : "text-gray-400"
                      }`}
                    />
                    {vendedor.isActive ? (
                     <button
                     type="button"
                     onClick={() => handleCopyLink(vendedor.creationLink)}
                     className="text-blue-500 hover:underline cursor-pointer bg-transparent border-0 p-0"
                   >
                     Link de criação ativo
                   </button>
                    ) : (
                      <span className="text-gray-400 italic">
                        Link de criação expirado
                      </span>
                    )}
                    <button
                      onClick={() => handleCopyLink(vendedor.creationLink)}
                      disabled={!vendedor.isActive}
                      className={`ml-2 transition-colors ${
                        vendedor.isActive
                          ? "text-gray-400 hover:text-blue-600"
                          : "text-gray-300 cursor-not-allowed"
                      }`}
                    >
                      <Clipboard size={16} />
                    </button>
                  </div>

                </div>
                <div className="mt-4 flex justify-between">
                  <div className="flex flex-col">
                  <span className="text-gray-500">Quantidade de carteiras: {vendedor.carteirasDoMes}</span>
                  <span className="text-gray-500">Total de carteiras: {vendedor.totalCarteiras}</span>
                  </div>
                  <StatusToggle
                    id={vendedor.id}
                    isActive={vendedor.isActive}
                    onToggle={handleStatusToggle}
                    activeText="Link Ativo"
                    inactiveText="Link Expirado"
                    activeBgColor="bg-green-500"
                    inactiveBgColor="bg-red-500"
                    activeTextColor="text-white"
                    inactiveTextColor="text-white"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default VendedoresContent;
